import React from 'react';
import { Alert, Button, Form, Input, Typography } from 'antd';
import useLogin from '../../helpers/useLogin';
import '../../style/LoginForm.css'; // Importing LoginForm-specific styles

interface LoginFormProps {
    onRecoverPassword: () => void; // Prop for handling password recovery
    onRegister: () => void; // Prop for handling registration
}

const LoginForm: React.FC<LoginFormProps> = ({ onRecoverPassword, onRegister }) => {
    const { error, isLoading, handleSubmit } = useLogin();
    const [form] = Form.useForm();
    const keepLoggedIn = false;
    const { Title, Text } = Typography;

    const onFinish = (values: { email: string; password: string }) => {
        handleSubmit(null, keepLoggedIn, values);
    };

    return (
        <Form
            form={form}
            layout="vertical"
            className="login-form auth-antd-form"
            onFinish={onFinish}
            autoComplete="on"
        >
            <div className="auth-form-header">
                <Title level={2}>Login</Title>
                <Text className="auth-form-subtitle">Sign in to continue to OSCAR.</Text>
            </div>

            {error && (
                <Alert
                    type="error"
                    showIcon
                    message={error}
                    className="auth-form-alert"
                />
            )}

            <Form.Item
                name="email"
                rules={[
                    { required: true, message: 'Please enter your email.' },
                    { type: 'email', message: 'Please enter a valid email address.' },
                ]}
                className="auth-form-item"
            >
                <Input
                    placeholder="Email"
                    autoComplete="email"
                    size="large"
                    disabled={isLoading}
                />
            </Form.Item>

            <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please enter your password.' }]}
                className="auth-form-item"
            >
                <Input.Password
                    placeholder="Password"
                    autoComplete="current-password"
                    size="large"
                    disabled={isLoading}
                />
            </Form.Item>

            <Form.Item className="auth-form-item auth-submit-item">
                <Button
                    type="primary"
                    htmlType="submit"
                    className="button auth-submit-button"
                    loading={isLoading}
                    block
                    size="large"
                >
                    {isLoading ? 'Logging in...' : 'Login'}
                </Button>
            </Form.Item>

            <div className="recover-password-link auth-link-row">
                <Button type="link" className="link-like-button" onClick={onRecoverPassword}>
                    Forgot Password?
                </Button>
            </div>

            <div className="register-link auth-link-row">
                <Text>Don't have an account? </Text>
                <Button type="link" className="link-like-button" onClick={onRegister}>
                    Register
                </Button>
            </div>
        </Form>
    );
};

export default LoginForm;
